/* eslint-disable ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import {
  mapBy,
  sortBy,
  uniq,
} from '@linc-technologies/linced-common/utils/arrays';

export default class UsageSetController extends Controller {
  @computed('model.groupTemplateIds.@each.grouping')
  get autogroupsGroupings() {
    return uniq(
      mapBy(sortBy(this.model.groupTemplateIds, 'grouping'), 'grouping'),
    );
  }

  @computed('model.assessmentTemplateIds.@each.grouping')
  get assessmentCategories() {
    return uniq(
      mapBy(sortBy(this.model.assessmentTemplateIds, 'category'), 'category'),
    );
  }
}
